"use strict";import{tag as e}from"../custom-tag.js";export function certificationIcon({height:t=16,width:l=16,hidden:r=!1,title:a="Certification"}={}){return e`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${a}"
    >
      <path
        fill="currentColor"
        d="M7.2 12.225a.23.23 0 0 0 .159-.066l2.4-2.4-.318-.318L7.2 11.68l-1.041-1.04-.318.318 1.2 1.2a.22.22 0 0 0 .159.066"
      />
      <path
        fill="currentColor"
        d="M21 5.775H3A.225.225 0 0 0 2.775 6v12a.225.225 0 0 0 .225.225h18a.225.225 0 0 0 .225-.225V6A.225.225 0 0 0 21 5.775m-.225 12H3.225V6.225h17.55z"
      />
      <path
        fill="currentColor"
        d="M5.775 13.307V16.2a.225.225 0 0 0 .35.187L7.8 15.27l1.675 1.117a.225.225 0 0 0 .35-.187v-2.893a3.225 3.225 0 1 0-4.05 0m3.6 2.473-1.45-.967a.23.23 0 0 0-.25 0l-1.45.967v-2.168a3.2 3.2 0 0 0 3.15 0zM7.8 8.025a2.775 2.775 0 1 1 0 5.55 2.775 2.775 0 0 1 0-5.55m11.4 1.35h-6.6v.45h6.6zm0 2.4h-6.6v.45h6.6zm-2.4 2.4h-4.2v.45h4.2z"
      />
    </svg>
  `}
//# sourceMappingURL=certification.js.map
